module.exports = __webpack_public_path__ + "static/media/Shop_full.a9129563.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/Services/Shop_full.png
// module id = 36
// module chunks = 0